import { render, staticRenderFns } from "./ReviewUser.vue?vue&type=template&id=1db480bc"
import script from "./ReviewUser.vue?vue&type=script&lang=js"
export * from "./ReviewUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports